<script setup lang="ts">
/** Notice 386AG(2)(a) — Corporate Controller */
import CddVarField from './cdd/CddVarField.vue';
import './allotDoc.css';
</script>

<template>
  <div class="allot-doc">
    <div class="doc-head">
      <div class="doc-meta">THE COMPANIES ACT 1967</div>
      <div class="doc-lbl-title">NOTICE FOR CONTROLLERS — Section 386AG(2)(a)</div>
      <div class="doc-company" style="font-size:13px">(Corporate Controller)</div>
    </div>

    <table class="cdd-tbl">
      <tbody>
        <tr>
          <td class="cdd-lcell">Company Name</td>
          <td><CddVarField field-key="company_name" label="Company Name" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Notice Date</td>
          <td><CddVarField field-key="notice_date" label="Notice Date" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Notice Recipient Name</td>
          <td><CddVarField field-key="notice_recipient_name" label="Notice Recipient Name" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Reply-to Address</td>
          <td><CddVarField field-key="reply_to_address" label="Reply-to Address" /></td>
        </tr>
      </tbody>
    </table>

    <p class="doc-sec-title">Particulars of Corporate Controller</p>
    <table class="cdd-tbl">
      <tbody>
        <tr>
          <td class="cdd-lcell">Corporate Name</td>
          <td><CddVarField field-key="controller_corporate_name" label="Corporate Controller Name" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">UEN / Registration No.</td>
          <td><CddVarField field-key="controller_uen" label="Controller UEN" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Registered Office</td>
          <td><CddVarField field-key="controller_registered_office" label="Registered Office" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Email</td>
          <td><CddVarField field-key="controller_email" label="Email" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Contact No.</td>
          <td><CddVarField field-key="controller_contact_no" label="Contact No." /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Legal Form</td>
          <td><CddVarField field-key="controller_legal_form" label="Legal Form" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Jurisdiction / Governing Statute</td>
          <td><CddVarField field-key="controller_jurisdiction_statute" label="Jurisdiction / Governing Statute" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Register Name</td>
          <td><CddVarField field-key="controller_register_name" label="Register Name" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Registration No.</td>
          <td><CddVarField field-key="controller_registration_no" label="Registration No." /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Date Became Controller</td>
          <td><CddVarField field-key="controller_became_date" label="Date Became Controller" /></td>
        </tr>
      </tbody>
    </table>

    <p class="doc-sec-title">Acknowledgement / Notice Signer</p>
    <table class="cdd-tbl">
      <tbody>
        <tr>
          <td class="cdd-lcell">Acknowledgement Signer Name</td>
          <td><CddVarField field-key="acknowledgement_signer_name" label="Acknowledgement Signer Name" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Acknowledgement Signer Role</td>
          <td><CddVarField field-key="acknowledgement_signer_role" label="Acknowledgement Signer Role" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Notice Signer Name</td>
          <td><CddVarField field-key="notice_signer_name" label="Notice Signer Name" /></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
